import React from 'react';

const BrowseIcon = () => {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 10C7.5 9.3125 7.09375 8.65625 6.5 8.28125C5.875 7.9375 5.09375 7.9375 4.5 8.28125C3.875 8.65625 3.5 9.3125 3.5 10C3.5 10.7188 3.875 11.375 4.5 11.75C5.09375 12.0938 5.875 12.0938 6.5 11.75C7.09375 11.375 7.5 10.7188 7.5 10ZM7.21875 12.4688C6.71875 12.8125 6.125 13 5.5 13C3.84375 13 2.5 11.6562 2.5 10C2.5 8.34375 3.84375 7 5.5 7C7.15625 7 8.5 8.34375 8.5 10C8.5 10.6562 8.28125 11.25 7.9375 11.75L9.34375 13.1562C9.53125 13.3438 9.53125 13.6875 9.34375 13.875C9.15625 14.0625 8.84375 14.0625 8.625 13.875L7.21875 12.4688ZM11 14V6H7.5C6.65625 6 6 5.34375 6 4.5V1H2C1.4375 1 1 1.46875 1 2V14C1 14.5625 1.4375 15 2 15H10C10.5312 15 11 14.5625 11 14ZM10.9688 5C10.9375 4.9375 10.9062 4.84375 10.8438 4.78125L7.21875 1.15625C7.15625 1.09375 7.0625 1.0625 7 1.03125V4.5C7 4.78125 7.21875 5 7.5 5H10.9688ZM0 2C0 0.90625 0.875 0 2 0H6.875C7.25 0 7.65625 0.1875 7.9375 0.46875L11.5312 4.0625C11.8125 4.34375 12 4.75 12 5.125V14C12 15.125 11.0938 16 10 16H2C0.875 16 0 15.125 0 14V2Z"
        fill="#1F1F1F"
      />
    </svg>
  );
};

export default BrowseIcon;
